import { forwardRef } from 'react';

import { Center, type CenterProps } from '@frontend/components';
import { WarningIcon } from '@frontend/components/src/components/mediaAndIcons/icons/iconSet';

type ProcessingFailureBadgeProps = CenterProps & {
  size: 'sm' | 'md';
};

export const ProcessingFailureBadge = forwardRef(
  ({ size, ...restProps }: ProcessingFailureBadgeProps, ref) => {
    return (
      <Center
        ref={ref}
        position="absolute"
        borderRadius={0.25}
        w={size === 'md' ? 3 : '14px'}
        h={size === 'md' ? 3 : '14px'}
        right={size === 'md' ? '5px' : '1px'}
        top={size === 'md' ? '5px' : '1px'}
        {...restProps}
      >
        <WarningIcon size={size === 'md' ? 3 : '14px'} color="alert.error" />
      </Center>
    );
  },
);
ProcessingFailureBadge.displayName = 'ProcessingFailureBadge';
